export default "__VITE_ASSET__CHPrylKQ__"